import type { Option } from '@vaaas/fpts/option';
import type { ID } from '@phi/newtype';
import type { Body, Face } from '@phi/jcore';
import type { Vertex } from '@phi/onshape';
import type { Texture } from 'three';

/**
 * Keeping track of bodies and faces carrying sketches
 */
export default class LoadedSketchElement {
    elementId: Option<ID<'element'>>;
    documentId: Option<ID<'document'>>;
    versionId: Option<ID<'version'>>;
    workspaceId: Option<ID<'workspace'>>;
    filename: Option<string>;
    image_id: unknown;
    texture: Texture | undefined;
    body_id: Body | 0;
    face_id: Face | 0;
    topLeftV: Vertex | 0;
    topRightV: Vertex | 0;
    bottomRightV: Vertex | 0;
    bottomLeftV: Vertex | 0;
    mesh: unknown;
    is_deleted: boolean;

    constructor() {
        this.elementId;
        this.documentId;
        this.versionId;
        this.workspaceId;
        this.filename;
        this.image_id;
        this.texture;
        this.body_id = 0;
        this.face_id = 0;
        this.topLeftV = 0;
        this.topRightV = 0;
        this.bottomRightV = 0;
        this.bottomLeftV = 0;
        this.mesh = null;
        this.is_deleted = false;
    }
}
